export const MINIMUM_LOADING_DISPLAY_TIME = 1250;
export const GIB_TO_TIB_THRESHOLD = 1024;
